import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ConnectorService } from '../connector.service';

export interface UpdateSocioDto {
  id: number;
  nom: string;
  prenom: string;
  date_naissance: string; // Format DD-MM-YYYY
  adresse: string;
  code_postal: string;
  ville: string;
  pays: string;
}

@Injectable({
  providedIn: 'root'
})
export class SocioService {
  private apiUrl = environment.backAPI;

  constructor(
    private http: HttpClient,
    private connector: ConnectorService
  ) {}

  updateSocio(socioData: UpdateSocioDto): Observable<boolean> {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.connector.token()
    };

    return this.http.post<boolean>(`${this.apiUrl}/socio`, socioData, { headers });
  }

  // Convertir une Date en format DD-MM-YYYY pour l'API
  formatDateForApi(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
}
